




















import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class RiskMatrixGrid extends Vue {
  private expanded: boolean = false;
}

